import { Maybe } from '@pylot-data/pylotschema'

type CurrencyConverterOptions = { showSymbol: Maybe<boolean> }

const defaultOptions: CurrencyConverterOptions = {
    showSymbol: true
}

export const formatCurrency = (
    currency: string | number,
    options?: CurrencyConverterOptions,
    quantity = 1
): string => {
    const { showSymbol } = options || defaultOptions
    let convertedCurrency = currency

    if (typeof currency === 'string') {
        if (currency === '') return ''

        if (currency.includes('CLP')) {
            convertedCurrency = currency.split('CLP')[0]
            convertedCurrency = convertedCurrency.replace(/\.|,/g, '')
        } else {
            convertedCurrency = currency.replace(/\$/g, '')
        }

        if (
            convertedCurrency.includes('.') &&
            convertedCurrency.includes(',')
        ) {
            convertedCurrency = convertedCurrency.replace(/\.|,/, '')
        }

        convertedCurrency = parseFloat(convertedCurrency) * quantity
    }

    if (isNaN(convertedCurrency as number)) {
        throw Error(`Cant parse, check your currency string, Exception message`)
    }

    return `${showSymbol ? '$' : ''}${Math.round(
        convertedCurrency as number
    ).toLocaleString('es-CL')}`
}
